// extracted by mini-css-extract-plugin
module.exports = {"chat":"styles_chat__8y7Mc","inputDescription":"styles_inputDescription__j1bAA"};